<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :parentData="parentData"
            @action="masterAction"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <g-dropdown v-bind="fiOptions"
                      endpoint="legal_entities"
                      :label="$t('Entidad')"
                      :formItemConfig="fiOptions"
                      :params="legal_entities"
                      :decorator="['ent_id', { rules: [{ required: false}] }]"
          >
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <g-lookup :label="$t('Diagnóstico')"
                    :formItemConfig="fiOptions"
                    endpoint="diag"
                    ref="diagnostico"
                    :decorator="['id_diag', { rules: [{ required: false}] }]">
          </g-lookup>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>

<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['id_instance'],
    data () {
      return {
        legal_entities: {
          legal_entities_absen: true
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'diagnosis_instance',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_diagnosis'
            },
            columns: [
              {title: 'Entidad', dataIndex: 'desentities', sorter: true},
              {title: 'Diagnóstico', dataIndex: 'desdiagnostico', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_diag'},
            {name: 'ent_id'}
          ]
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.$nextTick(() => {
              if (!JsUtils.isEmpty(action.record.id_diag)) {
                this.$refs.diagnostico && this.$refs.diagnostico.handleSearch(action.record.id_diag)
              }
            })
            break
        }
      }
    },
    computed: {
      parentData () {
        return {id_instance: this.id_instance}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/DiagnosisInstance.vue